
export function getInitialActiveSectionKey(phaseSection: any[], phaseNow: any): string {
  if (!phaseSection || phaseSection.length === 0) return phaseNow?.key || 'approval';

  const doNowSections = phaseSection.filter(
    (section: any) =>
      Array.isArray(section.tasks) &&
      section.tasks.length > 0 &&
      section.state === 'DO'
  );

  if (doNowSections.length > 0) {
    return String(doNowSections[0].key);
  }

  if (phaseNow?.key) {
    const currentPhaseSection = phaseSection.find(
      (section: any) => section.key === phaseNow.key
    );
    if (
      currentPhaseSection &&
      Array.isArray(currentPhaseSection.tasks) &&
      currentPhaseSection.tasks.length > 0
    ) {
      return phaseNow.key;
    }
  }

  return phaseNow?.key || '';
}
